export function parseLegislationUrl(url: string): { workId: string } | null {
  let parsedUrl: URL;

  try {
    parsedUrl = new URL(url);
  } catch {
    try {
      parsedUrl = new URL(`https://${url}`);
    } catch {
      return null;
    }
  }

  const hostname = parsedUrl.hostname.toLowerCase();
  if (hostname !== "legislation.govt.nz" && hostname !== "www.legislation.govt.nz") {
    return null;
  }

  const segments = parsedUrl.pathname.split("/").filter(Boolean);
  if (segments.length < 4) {
    return null;
  }

  const [part1, part2, part3, part4] = segments;
  return { workId: `${part1}_${part2}_${part3}_${part4}` };
}
